/* @flow */
import React from "react";
import axios from "axios";
import Autosuggest from "react-autosuggest";
import { RiCloseFill } from "react-icons/ri";
import isMobile from "ismobilejs";
import { stringify } from "rebem-classname";

const sugDefault = [];
export default class AutocompleteLocalidad extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onSuggestionsFetchRequested =
      this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested =
      this.onSuggestionsClearRequested.bind(this);
    this.getSuggestionValue = this.getSuggestionValue.bind(this);
    this.onChange = this.onChange.bind(this);
    this.renderSuggestion = this.renderSuggestion.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.restablecer = this.restablecer.bind(this);

    this.state = {
      suggestions: sugDefault,
      textoDelInput:
        this.props.localidadDefault != 0 ? this.getSuggestionDefault() : "",
      isFetching: false,
      cancelTokenSource: null,
    };
    this.debounceTimeout = null; // Timeout para el debounce
  }
  getSuggestionDefault() {
    const localidadId = this.props.localidadDefault;
    if (localidadId) {
      axios
        .post("/api/v1/localidadPorId/", {
          idLocalidad: localidadId,
        })
        .then((result) => {
          const rst = result.data;
          this.setState(
            {
              textoDelInput: rst ? rst.localidad : "",
            },
            () => this.props.onLugarSelected(rst)
          );
        })
        .catch((err) => console.log(err));
    }
    return "";
  }
  restablecer() {
    this.setState({ textoDelInput: "" });
    this.props.onLugarSelected(null);
    if (!this.props.noAutoFocusOnClear) this.inputName.input.focus();
  }
  onChange(event, { newValue }) {
    this.setState({
      textoDelInput: newValue,
    });
  }
  onSuggestionsFetchRequested({ value, reason }) {
    let valor;
    if (reason == "input-focused") {
      valor = "";
    } else {
      valor = value;
    }

    if (valor.length < 3) {
      return;
    }

    clearTimeout(this.debounceTimeout);

    this.debounceTimeout = setTimeout(() => {
      this.fetchSuggestions(valor);
    }, 300);
  }

  fetchSuggestions = (valor) => {
    if (this.state.cancelTokenSource) {
      this.state.cancelTokenSource.cancel("Cancelled due to new request.");
    }
    const cancelTokenSource = axios.CancelToken.source();
    this.setState({ isFetching: true, cancelTokenSource });

    let url =
      "/api/v1/localidades/?q=" +
      valor +
      (this.props.idProvincia ? "&p=" + this.props.idProvincia : "") +
      (!this.props.conRegiones ? "&r=" + 0 : "") +
      (this.props.conOfertas ? "&o=" + 1 : "");

    axios
      .get(url, { cancelToken: cancelTokenSource.token })
      .then((result) => {
        let rst = result.data;
        if (!rst.length) {
          rst = sugDefault;
        }
        this.setState({
          suggestions: rst,
          isFetching: false,
          cancelTokenSource: null,
        });
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          console.log("Previous request cancelled: ", error.message);
        } else {
          console.error("Error fetching suggestions:", error);
        }
        this.setState({ isFetching: false, cancelTokenSource: null });
      });
  };
  /**
   * Implement it to teach Autosuggest what should be the input value when suggestion is clicked.
   */
  getSuggestionValue(localidad) {
    return localidad.localidad;
  }
  onSuggestionsClearRequested() {
    this.setState({
      suggestions: sugDefault,
    });
  }
  onSuggestionSelected(event, { suggestion, suggestionValue }) {
    event.preventDefault();
    if (suggestion) {
      this.setState(
        {
          textoDelInput: suggestion.localidad,
        },
        () => this.props.onLugarSelected(suggestion)
      );
    }
  }
  /**
   * Use your imagination to define how suggestions are rendered.
   */
  renderSuggestion(item) {
    return (
      <div>
        <strong>{item.localidad}</strong>
      </div>
    );
  }

  onBlur(evt, { highlightedSuggestion }) {
    this.onSuggestionSelected(evt, { suggestion: highlightedSuggestion });
  }

  render() {
    const inputProps = {
      placeholder: "Localidad",
      value: this.state.textoDelInput,
      onChange: this.onChange,
      onBlur: this.onBlur,
      autoComplete: "new-password",
      disabled: this.props.disabled,
    };
    if (this.props.claseComentario) {
      inputProps.className = this.props.claseComentario;
    }
    const block = "AutocompleteLocalidad";
    return (
      <div className={stringify({ block })}>
        <div className={stringify({ block, elem: "contenedor" })}>
          <Autosuggest
            suggestions={this.state.suggestions}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            onSuggestionSelected={this.onSuggestionSelected}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.renderSuggestion}
            inputProps={inputProps}
            highlightFirstSuggestion={false}
            focusInputOnSuggestionClick={!isMobile.any}
            shouldRenderSuggestions={() => true}
            ref={(inputName) => (this.inputName = inputName)}
          />
          <div
            className={stringify({
              block,
              elem: "iconos",
              mods: { clearInput: true },
            })}
          >
            {this.state.textoDelInput != "" && !this.props.disabled ? (
              <RiCloseFill onClick={this.restablecer} />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
